import type {TicketTag, TicketTagGroup} from '../../types';

import {Collapse, Radio} from '@ds/components';

type TicketTopicSelectorProps = {
  groups: TicketTagGroup[];
  selectedTag: TicketTag | null;
  onSelect: (tag: TicketTag) => void;
};

const TicketTopicSelector: React.FC<TicketTopicSelectorProps> = ({
  groups,
  selectedTag,
  onSelect
}) => {
  return (
    <Collapse
      bordered={false}
      className="shrink-0 rounded-none bg-white"
      items={groups.map((group, index) => ({
        key: `${index}-${group.title}`,
        label: <span className="flex min-h-12.5 items-center">{group.title}</span>,
        children: (
          <div className="flex min-h-12.5 flex-col">
            {group.tags?.map((tag) => (
              <Radio
                className="px-7 py-2"
                key={tag.id}
                checked={selectedTag?.id === tag.id}
                onClick={() => onSelect(tag)}
              >
                {tag.title}
              </Radio>
            ))}
          </div>
        )
      }))}
    />
  );
};

export default TicketTopicSelector;
